import { Reservation } from '../api.reservations';
import { colors } from '../theme';

export type IconBadgeInfo = {
  bg: string;
  color: string;
  tooltip: string;
};

/** Null when the apartment has no smart lock configured — the badge slot should not render at all. */
export function getTtlockBadgeInfo(reservation: Reservation): IconBadgeInfo | null {
  const hasTtlock = reservation.apartmentTtlockEnabled === true || !!(reservation.ttlockPinCode || reservation.ttlockPinError);
  if (!hasTtlock) return null;

  const ok = !!reservation.ttlockPinCode;
  return {
    bg: ok ? colors.badgeGreenBg : '#fed7d7',
    color: ok ? colors.badgeGreenText : '#c53030',
    tooltip: ok
      ? `Smart lock PIN: ${reservation.ttlockPinCode}`
      : reservation.ttlockPinError
        ? `Smart lock error: ${reservation.ttlockPinError}`
        : 'Smart lock PIN not yet generated',
  };
}

/** Null when the guide has never been opened — the badge slot should not render at all. */
export function getGuideBadgeInfo(reservation: Reservation): IconBadgeInfo | null {
  if (!reservation.guideFirstOpenedAt) return null;
  return {
    bg: colors.badgeGreenBg,
    color: colors.badgeGreenText,
    tooltip: `Guide opened: ${new Date(reservation.guideFirstOpenedAt).toLocaleString()}`,
  };
}
